import English from '@uppy/locales/lib/en_US';
import French from '@uppy/locales/lib/fr_FR';
import Romanian from '@uppy/locales/lib/ro_RO';
import Ukrainian from '@uppy/locales/lib/uk_UA';
import Polish from '@uppy/locales/lib/pl_PL';
import Spanish from '@uppy/locales/lib/es_ES';

const getLocale = (currentLocale: string) => {
  switch (currentLocale) {
    case 'en':
      return English;
    case 'fr':
      return French;
    case 'ro':
      return Romanian;
    case 'uk':
      return Ukrainian;
    case 'pl':
      return Polish;
    case 'es':
      return Spanish;
    default:
      return English;
  }
};

export default getLocale;
